import { NgModule } from '@angular/core';
import { SharedModule } from 'lib-trend-core';
import { ChatHeaderComponent } from './chat-header.component';

@NgModule({
  imports: [
    SharedModule,
  ],
  declarations: [
    ChatHeaderComponent,
  ],
  exports: [
    ChatHeaderComponent,
  ],
})
export class ChatHeaderModule { }
